<template>
  <div class="documentation">
    <Breadcumb title="Ajouter un tag" :breadcumb-data="breadcumbData"></Breadcumb>
    <b-card class="cardcontainer">
      <b-form @submit="addCategory">
        <b-form-group label="Label en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Label" v-model="label_en" :state="errors['label_en'] ? 'invalid': ''"/>
          <div v-if="errors['label_en']" class="invalid-tooltip">{{ errors['label_en'][0] }}</div>
        </b-form-group>
        <b-form-group label="Label en Français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Label français" v-model="label" :state="errors.label ? 'invalid': ''"/>
          <div v-if="errors['label']" class="invalid-tooltip">{{ errors['label'][0] }}</div>
        </b-form-group>
        <b-form-group label="Couleur" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <compact-picker v-model="colors" />
        </b-form-group>
        <b-form-row>
          <div class="col-md-10 ml-md-auto">
            <b-btn type="submit" variant="primary">Modifier la question</b-btn>
          </div>
        </b-form-row>
      </b-form>
    </b-card>
  </div>
</template>
<style src="@/vendor/libs/vue-color/vue-color.scss" lang="scss"></style>
<script>
  import { ADMIN_ADD_TAG_REQUEST } from '../../_store/administration/questionnary/actiontypes';
  import { mapState } from 'vuex';
  var vueColor = require('vue-color');
  import Breadcumb from '../../components/breadcumb';

  export default {
    name: 'adminCategoryAdd',
    components: {
    'compact-picker': vueColor.Compact,
    Breadcumb
  },
    mounted() {
    },
    computed: mapState({ errors: state => state.admin_document.errors }),
    data() {
      return ({
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des questions', href: '/dashboard/administration/questionnary/' },
          { text: 'Ajouter un tag', active: true },
        ],
        label_en: '',
        label: '',
        colors: {
          hex: '#194d33',
          hsl: {
            h: 150,
            s: 0.5,
            l: 0.2,
            a: 1
          },
          hsv: {
            h: 150,
            s: 0.66,
            v: 0.30,
            a: 1
          },
          rgba: {
            r: 25,
            g: 77,
            b: 51,
            a: 1
          },
          a: 1
        }
      });
    },
    layout(context) {
      return 'layout';
    },
    methods: {
      addCategory: function (e) {
        e.preventDefault();
        this.$store.dispatch(ADMIN_ADD_TAG_REQUEST, {
          label_en: this.label_en,
          label: this.label,
          color: this.colors.hex
        })
          .then(() => {
            this.$router.push('/dashboard/administration/questionnary/');
          })
          .catch((error) => {
            console.log('error is ==');
            console.log(error);
          });
      }
    }
  };
</script>
